import { PageInfo } from 'syf-js-utilities/typings/analytics'

declare global {
  interface Window {
    QSI: {
      API: {
        load: () => void
        run: () => void
        unload: () => void
      }
    }
    _SFDDL: {
      pageInfo?: PageInfo
      apptimize?: {
        subject: string
        isVantageScoreMfeEnabled: boolean
        isCardStatusTrackerEnabled: boolean
        isReplaceYourCardEnabled: boolean
        isPaymentSecurityEnabled: boolean
        isDocumentCenterEnabled: boolean
      }
    }
  }
}

const triggerQualtrics = (): void => {
  window.QSI?.API?.unload()
  window.QSI?.API?.load()
  window.QSI?.API?.run()
}

export default triggerQualtrics
